import React from 'react';
import HomeSection from './HomeSection';

const sections = [
  { name: 'Home', component: <HomeSection /> },
];

export default sections;
